// File: src/pages/HomePage.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, CircularProgress, keyframes } from '@mui/material';
import { TokenResponse } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';

import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import FeatureList from '../components/FeatureList';
import { useUser } from '../context/UserContext';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HomePage = () => {
    const navigate = useNavigate();
    const { user, login, isLoading } = useUser();
    const { t } = useTranslation();
    const [isInitialLoadingLong, setIsInitialLoadingLong] = useState(false);

/*    useEffect(() => {
        if (user) navigate('/dashboard');
    }, [user, navigate]);*/

    useEffect(() => {
        if (isLoading) {
            const timer = setTimeout(() => {
                setIsInitialLoadingLong(true);
            }, 5000);
            return () => clearTimeout(timer);
        } else {
            setIsInitialLoadingLong(false);
        }
    }, [isLoading]);

    const handleSuccess = async (tokenResponse: TokenResponse) => {
        try {
            await login(tokenResponse);
            navigate('/dashboard');      // <-- ДОБАВЬ ЭТУ СТРОКУ
        } catch (loginError) {
            console.error(loginError);
        }
    };

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    flexDirection: 'column',
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
                }}
            >
                <CircularProgress size={50} />
                <Typography variant="h6" sx={{ mt: 2, textAlign: 'center' }}>
                    {isInitialLoadingLong ? t('loading.server_waking') : t('loading.initial_data')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: (theme) =>
                    `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Header onLoginSuccess={handleSuccess} isLoading={isLoading} />

            <Container
                component="main"
                sx={{
                    flexGrow: 1,
                    py: { xs: 4, md: 6 },
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box sx={{ animation: `${fadeIn} 1s ease-out`, mb: { xs: 2, md: 4 } }}>
                    <Typography
                        variant="h1"
                        component="h1"
                        sx={{
                            fontWeight: 700,
                            background: (theme) => `linear-gradient(45deg, ${theme.palette.primary.main} 30%, #FFB347 90%)`,
                            backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                            fontSize: { xs: '2.2rem', md: '3.5rem' },
                            lineHeight: 1.1,
                            mb: { xs: 0.5, md: 1 }
                        }}
                    >
                        {t('app_name')}
                    </Typography>
                </Box>

                <Paper
                    sx={{
                        p: { xs: 2, md: 3 },
                        maxWidth: '500px',
                        width: '100%',
                        mx: 'auto',
                        animation: `${fadeIn} 1s ease-out 0.3s`,
                    }}
                >
                    <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                        {t('home.platform_features')}
                    </Typography>
                    <FeatureList />
                </Paper>
            </Container>

            <Footer />
        </Box>
    );
};

export default HomePage;
